import React from "react";
import "./PortfolioLeaders.css";
import carlImg from "../../../images/carl_mc.png";
import bretImg from "../../../images/bret-fund.png";
import shamsahImg from "../../../images/shamsah-noorani.png";
import hawamaImg from "../../../images/hawama-sattar.png";

function PortfolioLeaders() {
  const leaders = [
    {
      image: bretImg,
      name: "Bret Fund",
      role: "Chief Executive Officer (CEO)",
      bio: "Bret Fund is a visionary leader and seasoned executive with over two decades of experience in education technology, workforce development, and enterprise innovation. As CEO of EdTech Ventures, he oversees the firm's strategic vision, portfolio operations, and capital deployment across transformative skills-based learning and AI talent companies."
    },
    {
      image: shamsahImg,
      name: "Shamsah Noorani",
      role: "Chief Executive Officer (CEO)",
      bio: "Shamsah Noorani, CEO of Health Tech Academy, is a distinguished Global Sales and Marketing Executive with over 15 years of experience. Shamsah excels in Sales, Marketing, Partnerships, and building high-performance teams."
    },
    {
      image: hawamaImg,
      name: "Dr. Hawama Sattar",
      role: "GM",
      bio: "Hawama Sattar is a global sales and marketing executive with 20+ years of experience in enterprise sales, client retention, and revenue growth in healthcare and education technology."
    },
    {
      image: carlImg,
      name: "Carl McCauley",
      role: "Chief Executive Officer",
      bio: "As the Chief Executive Officer, Carl brings over 25 years of technology, sales and management experience to 360factors. As CEO, Carl is responsible for leading 360factors business and product strategy, sales growth and market expansion.  Carl joined 360factors from Zycus, an industry-leader in procurement source-to-pay solutions, where he led the sales & solution consulting team as Senior Vice President of Sales and helped them become a leader in Gartner’s Strategic Sourcing Magic Quadrant."
    }
  ];

  return (
    <section className="portfolio-leaders py-5">
      <div className="container">

        <div className="text-center mb-5">
          <h2 className="pfLeader-title mb-2">
            Our Portfolio Leaders
          </h2>

          <div className="portfolio-divider"></div>
        </div>

        {leaders.map((leader, index) => (
          <div
            key={index}
            className="leader-card mb-4"
          >
            <div className="row g-0 align-items-stretch">

              <div className="col-lg-3 col-md-4">
                <img
                  src={leader.image}
                  alt={leader.name}
                  className="leader-image"
                />
              </div>

              <div className="col-lg-9 col-md-8">
                <div className="leader-content p-4">

                  <h3 className="leader-name mb-1">
                    {leader.name}
                  </h3>

                  <p className="leader-role mb-3">
                    ● {leader.role}
                  </p>

                  <p className="leader-bio mb-0">
                    {leader.bio}
                  </p>

                </div>
              </div>

            </div>
          </div>
        ))}

      </div>
    </section>
  );
}

export default PortfolioLeaders;